module.exports = __webpack_public_path__ + "img/pxyw.0945d062.png";